var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 22,
    viewBox: "0 0 73 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_83_9073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.0815e-06C3 8.0815e-06 66.6502 -1.01019e-05 70 8.0815e-06C69.9411 0.117308 69.8856 0.241487 69.8334 0.372042C66.7739 8.02682 62.4912 16 54.2476 16H18.6961C10.4716 16 6.27144 8.05155 3.1969 0.423339C3.13604 0.272334 3.07049 0.130924 3 8.0815e-06Z",
    fill: "#103045"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6491 11.1257L40.773 4.00108C40.839 3.88707 40.8738 3.7577 40.8739 3.62598C40.874 3.49426 40.8394 3.36483 40.7736 3.25072C40.7078 3.13661 40.6131 3.04184 40.4991 2.97594C40.385 2.91005 40.2556 2.87536 40.1239 2.87536L31.8761 2.87536C31.7444 2.87536 31.615 2.91005 31.5009 2.97594C31.3869 3.04184 31.2922 3.13661 31.2264 3.25072C31.1606 3.36483 31.126 3.49426 31.1261 3.62598C31.1262 3.75771 31.161 3.88708 31.227 4.00108L35.3509 11.1257C35.4168 11.2395 35.5114 11.334 35.6254 11.3997C35.7393 11.4654 35.8685 11.5 36 11.5C36.1315 11.5 36.2607 11.4654 36.3747 11.3997C36.4886 11.334 36.5832 11.2395 36.6491 11.1257Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_83_9073",
    x: 0.333336,
    y: 0,
    width: 72.3333,
    height: 21.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66666
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_83_9073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_83_9073",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeIcon);
export default __webpack_public_path__ + "static/media/resizeIcon.4ca7412c76ebdb6b80d53658c2d48709.svg";
export { ForwardRef as ReactComponent };